// pages/AdminPanel.js
import React, { useEffect, useState, useRef } from "react";
import AdminNavbar from "../components/AdminNavbar";
import OrdiniTable from "../components/OrdiniTable";
import ModalitaServizio from "../components/ModalitaServizio";
import MenuManager from "../components/MenuManager";
import PostiManager from "../components/PostiManager";
import DiscountManager from "../components/DiscountManager";
import AbbonamentiTable from "../components/AbbonamentiTable";
import "@fontsource/chivo";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const AdminPanel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [view, setView] = useState("ordini");

  const [newOrderIds, setNewOrderIds] = useState([]);
  const previousIdsRef = useRef([]);
  const isFirstLoad = useRef(true);
  const audioRef = useRef(null); // 🔊 for sound notification

  useEffect(() => {
    const isAdmin = localStorage.getItem("isAdmin");
    if (isAdmin !== "true") {
      navigate("/admin-login");
    }
  }, [navigate]);

  useEffect(() => {
    const pathToView = {
      "/admin-panel": "ordini",
      "/admin-servizio": "servizio",
      "/admin-menu": "menu",
      "/admin-sconti": "sconti",
      "/admin-posti": "posti",
      "/admin-abbonamenti": "abbonamenti",
      
    };
    setView(pathToView[location.pathname] || "ordini");
  }, [location.pathname]);

// 🔄 Global polling for new orders with sound notification
useEffect(() => {
  // we track last known "stato" per order id
  const prevStatusRef = { current: {} }; // { [id]: "pagato" | "non pagato" }
  const didInitRef = { current: false };
  const mountedAt = new Date(); // skip historical stuff

  const fetchOrders = () => {
    axios
      .get("https://api.lidodavittorio.it/api/orders")
      .then((res) => {
        // sort oldest -> newest for stable comparisons
        const all = res.data.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );

        // build current status map
        const currStatus = {};
        for (const o of all) currStatus[o.id] = o.stato;

        // detect ONLY transitions non pagato -> pagato for incompleti
        let newlyPaid = [];
        if (didInitRef.current) {
          newlyPaid = all
            .filter((o) => o.completato === "NO" && o.stato === "pagato")
            // we must have seen this id before
            .filter((o) =>
              Object.prototype.hasOwnProperty.call(prevStatusRef.current, o.id)
            )
            // it was not paid previously
            .filter((o) => prevStatusRef.current[o.id] !== "pagato")
            // not an ancient order from before this tab opened
            .filter((o) => new Date(o.created_at) >= mountedAt)
            .map((o) => o.id);

          if (newlyPaid.length > 0) {
            console.log("✨ AdminPanel newly paid IDs:", newlyPaid);
            setNewOrderIds((prev) => Array.from(new Set([...prev, ...newlyPaid])));

            // 🔊 Play sound
            if (audioRef.current) {
              audioRef.current.play().catch((err) => console.warn("Audio error:", err));
            }
          }
        } else {
          console.log("⏭ AdminPanel first poll — no notifications");
          didInitRef.current = true;
        }

        // snapshot AFTER computing transitions
        prevStatusRef.current = currStatus;
      })
      .catch((err) => {
        console.error("Errore nel caricamento ordini:", err);
      });
  };

  fetchOrders();
  const interval = setInterval(fetchOrders, 5000);
  return () => clearInterval(interval);
}, []);


  return (
    <div className="bg-white text-black min-h-screen flex flex-col">
      {/* 🔊 Hidden audio element */}
      <audio ref={audioRef} src="/notification.mp3" preload="auto" />
      
      <AdminNavbar newOrderCount={newOrderIds.length} />
      <div className="pt-8 px-4 sm:px-6 text-center flex-1 w-full">
        {view === "ordini" && <OrdiniTable />}
        {view === "servizio" && (
          <ModalitaServizio
            newOrderIds={newOrderIds}
            setNewOrderIds={setNewOrderIds}
          />
        )}
        {view === "menu" && <MenuManager />}
        {view === "sconti" && <DiscountManager />}
        {view === "posti" && <PostiManager />}
        {view === "abbonamenti" && <AbbonamentiTable />}

      </div>
    </div>
  );
};

export default AdminPanel;
